import { AsyncPipe, DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ProductContextDisplayProperties, ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { FeatureToggleModule } from 'ish-core/feature-toggle.module';
import { ProductView } from 'ish-core/models/product-view/product-view.model';

import { CompareExportsModule } from '../../../extensions/compare/exports/compare-exports.module';
import { WishlistsExportsModule } from '../../../extensions/wishlists/exports/wishlists-exports.module';

@Component({
  selector: 'ish-product-detail-actions',
  templateUrl: './product-detail-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FeatureToggleModule,
    WishlistsExportsModule,
    CompareExportsModule,
    FaIconComponent,
    AsyncPipe,
    TranslateModule,
  ],
})
export class ProductDetailActionsComponent implements OnInit {
  // TODO: to be removed once channelName information available in system
  channelName = 'inTRONICS';

  product$: Observable<ProductView>;

  private context = inject(ProductContextFacade);
  document: Document = inject(DOCUMENT);

  ngOnInit() {
    this.product$ = this.context.select('product');
  }

  configuration$(key: keyof ProductContextDisplayProperties) {
    return this.context.select('displayProperties', key);
  }
}
